var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row primary-text" }, [
      _c(
        "div",
        {
          staticClass: "col-12 mt-3",
          class: _vm.featured ? "col-md-4" : "col-md-12"
        },
        [
          _c("a", { attrs: { href: _vm.href } }, [
            _c("h2", {
              staticClass: "fs-h2 font-family-alternative text-uppercase",
              domProps: { innerHTML: _vm._s(_vm.title) }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-12 mt-3",
          class: _vm.featured ? "col-md-7 offset-md-1" : "col-md-12"
        },
        [
          _c("a", { attrs: { href: _vm.href } }, [
            _c("p", {
              staticClass: "mb-4 fs-smalltext aicon-arrow",
              domProps: { innerHTML: _vm._s(_vm.description) }
            })
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }